<template>
  <div>
    <div class="page-header header-filter header-tiny bg-1">
      <b-container>
        <b-row align-h="center">
          <b-col >
            <b-img fluid width="75" center src="/assets/img/Diamond_Cluster.png" />
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col>
          <h1 class="centre">{{ quest.title }}</h1>
          <h4 class="centre">{{ quest.type }}</h4>
          </b-col>
        </b-row>
        
      </b-container>
    </div>
    <div class="page-body">
      <b-container>
        <b-row>
          <b-col>
            <b-table-lite
              v-if="isTableData"
              striped
              responsive
              borderless
              hover
              tbody-tr-class="table-row"
              :items="currentPage"
              :fields="fields"
              @row-clicked="onRowClicked"
            ></b-table-lite>
            <b-spinner v-else variant="light" />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import utils from "../utils.js";
import { BTableLite, BImg } from "bootstrap-vue";

const { mapState, mapActions } = createNamespacedHelpers("questLeaderboard");

export default {
  name: "QuestLeaderboard",
  props: ["id"],
  components: { BTableLite, BImg },
  async created() {
    await this.loadQuest(this.id);
    this.updateScoreLabel();
    await this.loadPage();
  },
  computed: {
    ...mapState(["quest", "currentPage"]),
    isTableData() {
      return this.currentPage?.length > 0;
    },
  },
  methods: {
    ...mapActions(["loadQuest", "loadPage"]),
    formatScore(score) {
      return utils.timeStrFromSecsStr(score, this.quest?.type);
    },
    updateScoreLabel() {
      console.log(`Quest: ${this.quest}`);
      const str = this.quest?.type == "CheckpointRun" ? "Checkpoint" : "Time";
      this.fields.find((o) => o.key == "score").label = str;
    },
    onRowClicked(item, index) {
      console.log(`Item: ${JSON.stringify(item)}. Index: ${index}. PID: ${item.player.id}.`);
      this.$router.push({ name: "player", params: { id: item.player.id } });
    },
  },
  data() {
    return {
      fields: [
        { key: "rank" },
        { key: "score", label: "", formatter: this.formatScore },
        { key: "player.name", label: "Player" },
        { key: "createdAt", label: "Date", formatter: utils.dateStrToLocale },
      ],
    };
  },
};
</script>

<style>
</style>